import { Box, Center, Spinner } from '@chakra-ui/react';

const Loader = ({ isOpen }) => {
  if (!isOpen) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100%"
      zIndex={9999}
    >
      <Center
        position="absolute"
        top={0}
        left={0}
        width="100%"
        height="100%"
        backgroundColor="rgba(0, 0, 0, 0.3)"
      >
        <Spinner
          thickness="4px"
          speed="1s"
          emptyColor="gray.200"
          color="blue.500"
          size="xl"
          width="40px"
          height="40px"
        />
      </Center>
    </Box>
  );
};

export default Loader;
